export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M9.013 13.477c0 .537.34.684.76.33l5.912-5.16a.812.812 0 000-1.284l-5.912-5.17c-.42-.355-.76-.206-.76.33V6h-1C4.193 6 .926 9.166.13 12.586a5.59 5.59 0 00-.125.77c-.03.268.1.327.29.139 0 0 .055-.048.1-.1a11.46 11.46 0 017.62-3.4h1l-.002 3.483z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};